import { render, staticRenderFns } from "./competitorPriceComparison.vue?vue&type=template&id=75a759b8&scoped=true"
import script from "./competitorPriceComparison.vue?vue&type=script&lang=js"
export * from "./competitorPriceComparison.vue?vue&type=script&lang=js"
import style0 from "./competitorPriceComparison.vue?vue&type=style&index=0&id=75a759b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a759b8",
  null
  
)

export default component.exports